module.exports = __webpack_public_path__ + "img/video.115f756e.png";